import React, { useCallback, useMemo } from "react";
import { FilterIcon } from "@icons/FilterIcon";
import { Select } from "@ui-kit/Select/Select";
import {
  selectCategories,
  selectMenuItem,
  selectSelectedCategoryIds,
} from "@store/menuItem/menuItemReducer";
import { useAppDispatch, useAppSelector } from "@store/store";
import { setSelectedCategoryIdsAction } from "@store/menuItem/menuItemReducer";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

const CategoryFilter = () => {
  const dispatch = useAppDispatch();
  const menuItem = useAppSelector(selectMenuItem);
  const categoryFilterEnabled = menuItem.categoryFilterEnabled;
  const categories = useAppSelector(selectCategories);
  const selectedCategoryIds = useAppSelector(selectSelectedCategoryIds);

  const menuItems = useMemo(() => {
    return menuItem.categoryIds
      .map((categoryId) => {
        const category = categories.find((c) => c.id === categoryId);
        if (!category) {
          return null;
        }

        return {
          label: category.name,
          value: String(category.id),
        };
      })
      .filter((item) => !!item);
  }, [categories, menuItem.categoryIds]);

  const handleToggleCategory = useCallback(
    (categoryIds: string[]) => {
      const categoryIdsNumber = categoryIds.map((x) => Number(x));
      dispatch(setSelectedCategoryIdsAction(categoryIdsNumber));
    },
    [dispatch],
  );

  return (
    <>
      {categoryFilterEnabled && menuItems.length > 0 && (
        <Select
          isMultiSelect={true}
          selectedValues={selectedCategoryIds.map((x) => String(x))}
          items={menuItems}
          label="Filters"
          onChange={handleToggleCategory}
          prefixIcon={<FilterIcon color={colors.neutral600} size={16} />}
        />
      )}
    </>
  );
};

export { CategoryFilter };
